var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.dialogs, function (dialog, index) {
      return _c("CaDialog", {
        key: "ca-dialog-" + index,
        attrs: {
          active: true,
          "dialog-id": dialog.id,
          "dialog-class": dialog.dialogClass,
          type: dialog.type,
          title: dialog.title,
          text: dialog.text,
          html: dialog.html,
          buttons: dialog.buttons,
          "has-cancel-button": dialog.hasCancelButton,
          "cancel-button-text": dialog.cancelButtonText,
          "cancel-callback": dialog.cancelCallback,
          "has-confirm-button": dialog.hasConfirmButton,
          "confirm-button-text": dialog.confirmButtonText,
          "confirm-callback": dialog.confirmCallback,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }